import { getListSerchMypage, postSerchMypage, deleteSerchMypage as deleteSerchMypageEP, getSingleSerchMypage } from '@/api/serchMyPageEndpoint';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import { JobSearchSelectedCheckboxListItem } from '@/types';
import { TrnSearchMyPageAddRequest } from '@/types/request';

type SerchMyPageContent = {
  jobsearch_anualslryvalue?: string;
  jobsearch_areaid?: string;
  jobsearch_cityid?: string;
  jobsearch_features?: string;
  jobsearch_features_order?: string;
  jobsearch_indsctggroupid?: string;
  jobsearch_indsctgid?: string;
  jobsearch_keywordfirst?: string;
  jobsearch_keywordsecond?: string;
  jobsearch_keywordthird?: string;
  jobsearch_ocupctg1id?: string;
  jobsearch_ocupctg2id?: string;
  jobsearch_ocupctg3id?: string;
  jobsearch_possibleovertime?: string;
  jobsearch_prefid?: string;
  jobsearch_remotework?: string;
  jobsearch_sidebusiness?: string;
  [key: string]: string | undefined;
}

type TrnSerchMyPageDetailResponse = {
  careerId: number;
  insertDate: string;
  serchContent: string;
  serchName?: string;
  srchId: number;
  updateDate: string;
}

export type TrnSerchMyPageInfo = {
  srchId?: number;
  annualIncome?: string;
  location?: string;
  occupation?: string;
  other?: string;
  serchContentObj?: SerchMyPageContent;
}

export type JobSearchCardData = TrnSerchMyPageInfo & {
  isSaved: boolean;
}

export type DialogSearchSelectedData = {
  keyword: {
    field?: string;
    value?: string;
  }
  jobsearchAnualslry?: {
    id: number;
    text: string;
  },
  location: {
    jobsearchAreaid: string[],
    jobsearchPrefid: number[],
    jobsearchCityid: number[],
    displayLocationList: JobSearchSelectedCheckboxListItem[],
  },
  occupation: {
    jobsearchOcupctg1id: string[],
    jobsearchOcupctg2id: string[],
    jobsearchOcupctg3id: string[],
    displayOccupList: JobSearchSelectedCheckboxListItem[]
  },
  industry: {
    jobsearchIndsctgGroupId: string[],
    jobsearchIndsctgId: number[],
    displayIndustryList: JobSearchSelectedCheckboxListItem[],
  },
  jobsearchPossibleOvertime?: {
    id: number;
    text: string;
  };
  jobsearchRemotework?: {
    id: number;
    text: string;
  },
  jobsearchSideBusiness?: number;
  jobsearchFeatures?: number[];
  jobsearchFeaturesOrder?: number[];

  isSaveSearchCondition: boolean;
}

function parseQueryString(queryString: string) {
  const params = new URLSearchParams(queryString);
  const obj: SerchMyPageContent = {};

  params.forEach((value, key) => {
    obj[key] = value;
  });

  if (obj.jobsearch_areaid) {
    const areaIds = obj.jobsearch_areaid.split(',');
    for (let i = 0; i < areaIds.length; i++) {
      if (areaIds[i] == MYPAGE_CONSTANTS.MSTAREA_FOREIGN_ID_OLD) {
        areaIds[i] = MYPAGE_CONSTANTS.MSTAREA_FOREIGN_ID;
      }
    }
    obj.jobsearch_areaid = areaIds.join(',');
  }

  if (obj.jobsearch_indsctggroupid) {
    const indsctgGroupId = obj.jobsearch_indsctggroupid.split(',');
    for (let i = 0; i < indsctgGroupId.length; i++) {
      if (indsctgGroupId[i].length == 4) {
        indsctgGroupId[i] = indsctgGroupId[i].substring(0, 2);
      }
    }
    obj.jobsearch_indsctggroupid = indsctgGroupId.join(',');
  }

  return obj;
}

export const getSerchMyPageListService = async (limit?: number) => {
  const response = await getListSerchMypage(limit);
  const detail = response.detail as TrnSerchMyPageDetailResponse[];
  if (detail) {
    const serchList = detail.map((serchItem) => {
      const serchContent = convertSerchContent(serchItem);
      return {
        srchId: serchItem.srchId,
        serchContentObj: serchContent[1],
        other: serchContent[0],
      } as TrnSerchMyPageInfo;
    });
    return serchList;
  }
  return [];
};

export const getSerchMyPageService = async (serchId: number) => {
  const response = await getSingleSerchMypage(serchId);
  if (response.detail) {
    const serchContent = convertSerchContent(response.detail);
    return {
      srchId: response.detail.srchId,
      serchContentObj: serchContent[1],
      other: serchContent[0],
    } as TrnSerchMyPageInfo;
  }
  return null;
};

export const addSerchMyPageService  = async (search: TrnSearchMyPageAddRequest) => {
  const response = await postSerchMypage(search);
  return response;
};

export const deleteSerchMypageService = async (serchId: number) => {
  const response = await deleteSerchMypageEP(serchId);
  return response;
};

function convertSerchContent(serchItem: TrnSerchMyPageDetailResponse){
  const serchContent = parseQueryString(serchItem.serchContent);
  if(!serchItem.serchContent.includes('&jobsearch_keywordthird=')){

    let newKeywordOther = '';
    if(serchContent.jobsearch_keywordsecond){
      newKeywordOther = serchContent.jobsearch_keywordsecond;
    } else if(serchContent.jobsearch_keywordfirst){
      newKeywordOther = serchContent.jobsearch_keywordfirst;
    }

    const regex = /キーワード：((?:(?!＋残業時間（月間）：|＋リモートワークの有無：|＋副業の可否：|\.\.\.).)+)/g;
    serchItem.serchName = serchItem.serchName?.replace(regex, 'キーワード：' + newKeywordOther);
  }
  const serchName = serchItem.serchName ? serchItem.serchName : '-';
  return [serchName, serchContent];
}